var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProyectosLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file 1",
    clipPath: "url(#clip0_3_91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8781 4.43961C17.8564 4.43961 17.8564 4.41785 17.8346 4.39608C17.8128 4.37432 17.8128 4.35256 17.7911 4.33079L14.0479 0.130577C14.0261 0.108814 13.9826 0.0870511 13.9608 0.0652884C13.9391 0.0652884 13.9391 0.0435256 13.9173 0.0435256C13.8738 0.0217628 13.8085 0 13.7432 0H4.55929C3.21 0 2.1001 1.1099 2.1001 2.45919V17.5408C2.1001 18.8901 3.21 20 4.55929 20H15.4407C16.79 20 17.8999 18.8901 17.8999 17.5408V4.59195C17.8999 4.54842 17.8781 4.48313 17.8781 4.43961ZM14.1567 1.47987L16.5723 4.20022H14.1567V1.47987ZM17.0729 17.519C17.0729 18.4331 16.3547 19.173 15.4407 19.173H4.55929C3.64526 19.173 2.92708 18.4331 2.92708 17.5408V2.43743C2.92708 1.52339 3.66702 0.805223 4.55929 0.805223H13.3297V4.59195C13.3297 4.80958 13.5038 5.00544 13.7432 5.00544H17.0729V17.519Z",
    fill: "#001251"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.03807 5.00544H8.67245C8.89008 5.00544 9.08594 4.83134 9.08594 4.59194C9.08594 4.35255 8.91184 4.17845 8.67245 4.17845H5.03807C4.82044 4.17845 4.62457 4.35255 4.62457 4.59194C4.62457 4.83134 4.82044 5.00544 5.03807 5.00544Z",
    fill: "#001251"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.67245 14.9946H5.03807C4.82044 14.9946 4.62457 15.1687 4.62457 15.408C4.62457 15.6257 4.79867 15.8215 5.03807 15.8215H8.67245C8.89008 15.8215 9.08594 15.6474 9.08594 15.408C9.08594 15.1904 8.89008 14.9946 8.67245 14.9946Z",
    fill: "#001251"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.62457 7.33406C4.62457 7.55168 4.79867 7.74755 5.03807 7.74755H14.7443C14.9619 7.74755 15.1578 7.57345 15.1578 7.33406C15.1578 7.11643 14.9837 6.92056 14.7443 6.92056H5.03807C4.82044 6.92056 4.62457 7.09467 4.62457 7.33406Z",
    fill: "#001251"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.7443 8.96626H5.03807C4.82044 8.96626 4.62457 9.14036 4.62457 9.37976C4.62457 9.59738 4.79867 9.79325 5.03807 9.79325H14.7443C14.9619 9.79325 15.1578 9.61915 15.1578 9.37976C15.1578 9.14036 14.9837 8.96626 14.7443 8.96626Z",
    fill: "#001251"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.7443 10.9902H5.03807C4.82044 10.9902 4.62457 11.1643 4.62457 11.4037C4.62457 11.6213 4.79867 11.8172 5.03807 11.8172H14.7443C14.9619 11.8172 15.1578 11.6431 15.1578 11.4037C15.1578 11.1643 14.9837 10.9902 14.7443 10.9902Z",
    fill: "#001251"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.7443 13.0141H5.03807C4.82044 13.0141 4.62457 13.1882 4.62457 13.4276C4.62457 13.6453 4.79867 13.8411 5.03807 13.8411H14.7443C14.9619 13.8411 15.1578 13.667 15.1578 13.4276C15.1578 13.21 14.9837 13.0141 14.7443 13.0141Z",
    fill: "#001251"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProyectosLogo);
export default __webpack_public_path__ + "static/media/Proyectos-logo.53c7b603ac4ce118e599b60ce2db5879.svg";
export { ForwardRef as ReactComponent };